import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchWorkdays } from "../actions/index";
import * as constants from "../const";
import { showModalAction, getWorkdayAction,showModalUpdateManual } from "../actions/index";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/src/SuperResponsiveTableStyle.css";
import moment from "moment";
import './manuallyUpdate.css';
import UpdatePopup from "./updatePopup";
import accepted_condition from '../const.js'

class ClaimsEmployeesWorkday extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false
    };
  }

  editPopup() {
    this.setState({
      showPopup: !this.state.showPopup 
    });
  }

  onUpdateSuccessfull() {
    this.setState({
      showPopup: false
    });
  }
  

// show claimed employee details
  showModal(modalObj) {
    this.props.onShowModal(modalObj.modalName);
    var route = localStorage.getItem("route");
    var category = route;
    var workdayDate = moment(modalObj.workdayDate, 'MM/DD/YYYY')
    workdayDate = workdayDate.format('YYYYMMDD');
    let role = this.props.role;
    this.props.getWorkday(
      constants.actionUrls.WORKDAY_URL + "/" + role + "/" + modalObj.workdayId + "/" + modalObj.certifyStatus
      + "/" + modalObj.empId + "/" + workdayDate + "/" + modalObj.dutyActivityStatus
    );
  }
  showUpdateModal(id){
    this.props.onShowModal("manual_update_modal");
    this.props.showModalUpdateManual(id);
  }

  // for showing difference in HOS
  renderDifferentialHOS(hosDiffInHH, hosDiffInMM) {
    return hosDiffInHH > 0 ? (
      <span className="green">
        {" "}
        +{hosDiffInMM < 0 ? hosDiffInHH - 1 : hosDiffInHH}h{hosDiffInMM >= 0 ? hosDiffInMM : 60 + hosDiffInMM}{" "}
      </span>
    ) : hosDiffInHH == 0 && hosDiffInMM == 0 ? (0) : hosDiffInHH == 0 ? hosDiffInMM < 0 ? (
      <span className="red">
        {" "}-0h{hosDiffInMM * -1}
      </span>
    ) : (
      <span className="green">
        {" "}+0h{hosDiffInMM}
      </span>
    ) : (
      <span className="red">
        {hosDiffInMM >= 0 ? hosDiffInHH + 1 : hosDiffInHH}h{hosDiffInMM >= 0 ? 60 - hosDiffInMM : hosDiffInMM * -1}{" "}
      </span>
    );
  }

  // for showing difference in TOS
  renderDifferentialTOS(tosDiffInHH, tosDiffInMM) {
    if(isNaN(tosDiffInHH) && isNaN(tosDiffInMM)){
      return <span>0</span>;
    } else {
      return tosDiffInHH > 0 ? (
            <span className="green">
              {" "}
              +{tosDiffInMM < 0 ? tosDiffInHH - 1 : tosDiffInHH}h{tosDiffInMM >= 0 ? tosDiffInMM : 60 + tosDiffInMM}{" "}
            </span>
          ) : tosDiffInHH == 0 && tosDiffInMM == 0 ? (0) : tosDiffInHH == 0 ? tosDiffInMM < 0 ? (
            <span className="red">-0h{tosDiffInMM * -1}</span>
          ) : (
            <span className="green">{" "}+0h{tosDiffInMM}</span>
          ) : (
            <span className="red">
              {tosDiffInMM >= 0 ? tosDiffInHH + 1 : tosDiffInHH}h{tosDiffInMM >= 0 ? 60 - tosDiffInMM : tosDiffInMM * -1}{" "}
            </span>
          );
    }    
  }
  render() {
    if (this.props.workday) {
      var showManualCols = this.props.parent === 'Manual' ; 
      var workday = this.props.workday,division = '-';
      division = workday.division ? workday.division : '-';
      var adjustedHOS = workday.wdy_working_time_hos_adjust
        ? workday.wdy_working_time_hos_adjust
        : workday.wdy_working_time_hos;
      var adjustedTOS = workday.wdy_spread_adjust
        ? workday.wdy_spread_adjust
        : workday.wdy_spread;
      var hastus = workday.hastus_updated == true ?  "Updated" :  "";
      var user_name = workday.lst_updt_user;
      var updatedDate = workday.updated_date;
      var time = workday.updated_time;
      var signinError= workday.signin_error_message;
      var signoutError = workday.signout_error_message;       
      
        // workday.test =test;
      var full_name = workday.emp_full_name.split(" "),
        first_name = full_name[1],
        last_name = full_name[0],
        hos = workday.wdy_working_time_hos,
        tos = workday.wdy_spread,
        splittedHOS = hos.split("h"),
        splittedHOSInHH = splittedHOS[0],
        splittedHOSInMM = splittedHOS[1],
        splittedTOS = tos.split("h"),
        splittedTOSInHH = splittedTOS[0],
        splittedTOSInMM = splittedTOS[1],
        splitAdjustedHOS = adjustedHOS.split("h"),
        splitAdjustedHOSInHH = splitAdjustedHOS[0],
        splitAdjustedHOSInMM = splitAdjustedHOS[1],
        splitAdjustedTOS = adjustedTOS.split("h"),
        splitAdjustedTOSInHH = splitAdjustedTOS[0],
        splitAdjustedTOSInMM = splitAdjustedTOS[1],
        hosDiffInHH =parseInt(splitAdjustedHOSInHH) - parseInt(splittedHOSInHH),
        hosDiffInMM =parseInt(splitAdjustedHOSInMM) - parseInt(splittedHOSInMM),
        tosDiffInHH =parseInt(splitAdjustedTOSInHH) - parseInt(splittedTOSInHH),
        tosDiffInMM =parseInt(splitAdjustedTOSInMM) - parseInt(splittedTOSInMM);
      var modalObj = {
          workdayId:workday.id,
          certifyStatus:localStorage.getItem('route'),
          empId:workday.demp_display_Id,
          workdayDate:workday.wdy_date,
          modalName:"Certified_Modal",
          dutyActivityStatus:workday.dutyActivityStatus
      }
     
      return (
        <tr>
          <td data-title="Division">{division}</td>
          <td data-title="Employee ID" className="text-center">
            <a className="popUpLink" onClick={() =>
                this.showModal(modalObj)}>
                {workday.demp_display_Id}
            </a>
          </td>
          <td data-title="Job" className="text-center">{workday.job_class}</td>  
          <td data-title="First Name" className="text-center"> {first_name} </td>
          <td data-title="Last Name" className="text-center"> {last_name} </td>
          <td data-title="Service Date" className="text-center"> {workday.wdy_date} </td>
          <td className="timeColumn">
            <table className=" responsiveTable">
              <tbody>
                  <tr>
                    <td data-title="System HOS" className="text-center">{workday.wdy_working_time_hos} </td>
                    <td data-title="System TOS" className="text-center">{workday.wdy_spread} </td>                    
                  </tr>
                </tbody>
              </table>
          </td>
          <td className="timeColumn">
            <table className=" responsiveTable">
              <tbody>
                  <tr>
                      <td data-title="Adjusted HOS" className="text-center">{adjustedHOS} </td>
                      <td data-title="Adjusted HOS" className="text-center">{adjustedTOS} </td>                 
                  </tr>
                </tbody>
              </table>
          </td>
          <td className="timeColumn">
            <table className=" responsiveTable">
              <tbody>
                  <tr>
                    <td data-title="Differential HOS" className="text-center">
                      {this.renderDifferentialHOS(hosDiffInHH, hosDiffInMM)}
                    </td>
                    <td data-title="Differential HOS" className="text-center">
                      {this.renderDifferentialTOS(tosDiffInHH, tosDiffInMM)}
                    </td>
                  </tr>
                </tbody>
              </table>
          </td>
          <td  data-title="Date" className="text-center">{workday.wdy_claim_date} </td>
          
          {/* Newly Created Hastus Status Column for Accepted Claims and User Name, Time, Date, SigninError, SignOutError for Manually Update Hastus        */}
          <td data-title="Hastus Status" id="tooltip" className={showManualCols ? "hidden" : "text-center"}>{hastus}<span id="tooltiptext">{user_name}<br/>{time}<br/>{updatedDate}</span></td> 
          <td  data-title="Action" className={showManualCols?"text-center" : "hidden"}>
            <button type="button" className="btn btn-primary" onClick = {() => this.showUpdateModal(workday.id)}>Edit</button>
          </td>
        </tr>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    workdays: state.workdays.workdays,
    pageNum: state.workdays.pageNum
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchWorkdays: fetchWorkdays,
      onShowModal: showModalAction,
      showModalUpdateManual:showModalUpdateManual,
      getWorkday: getWorkdayAction
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(
  ClaimsEmployeesWorkday
);
